import axios, { AxiosResponse } from 'axios';
import { history } from '../..';
import { toast } from 'react-toastify';
import { ICompany, ICompanyRegistrationSettings, ILanguage } from '../models/company';
import { AuthenticatorQRcodeInfo, IAuthenticatorFormValues, IChangePwdFormValues, IOtpFormValues, IResetPwdFormValues, IUser, IUserConfirmResetPwdValues, IUserFormValues, IUserProfile, IUserProfileFormValues, LoginAuthenticatorApp, RegistrationFormValues } from '../models/user';import { ITenant } from '../models/tenant';
import { IBoardTreePageDto, IMeetingContentTreePageDto, IMeetingEditPageDto, IPlayerSignin, IRepositoryUserTreePageDto, ISidebar, ISurveyResult, PlayerBrowsePageDto, PresentationDetailDto, SurveyReponsesPageDto, zoomPortionValue } from '../models/dto';
import { IPlayerContent, IZwibblerDrawing, IZwibblerDrawingFormValues } from '../models/content';
import { ISearchOptions, ISearchPageDto } from '../models/search';
import { ISurveyDetailsDto, SurveyDetailFormValues, SurveyDetailsPlayerDto, SurveyEvent, SurveyResponseFormValue, Votes } from '../models/survey';
import { IQuorumResultDto, ISurveyEditResponseDto, ISurveyPageDto, ISurveyType } from '..//models/dto';
import { INodeDetail, INodeGeneric } from '../models/node';
import { IToolbar } from '../models/toolbar';
import { INote } from '../models/note';
import {IScreenStatus, IUserScreens } from '../models/screens';
import { SharedWidgetType } from '../models/widget';
import { getToastTranslation } from '../helpers/translationHelper';
import { IPodiumData, ISpeakerContent } from '../models/podium';
import { IGuestContent, IPresentationInfo, IScreenInfo, IValidatedGuest } from '../models/guest';
import { IDiskUser, IPresentationEditPageDto, IResultUploadFilesDto, PresentationDetailsFormValues } from '../models/repositoryUser';
import { IContentTreePageDto } from '../models/archive';
import { BroadcastDto, BroadcastUserDataDto, SynchronizedBroadcastStatus, UserTypes } from '../models/broadcast';
import { AudioDevice, CaboloStatus, ICaboloMeetingInfo, IcaboloRecodingFormValues, IRecordingMeetingPageDto, LanguagePair, RecStatus, TranscriptionModel } from '../models/cabolo';
import caboloStore from '../stores/caboloStore';



axios.defaults.baseURL = (process.env.REACT_APP_API_URL) ? process.env.REACT_APP_DOMAIN + process.env.REACT_APP_API_URL : "/api";
axios.defaults.withCredentials = true;

// Funzione per convertire un Blob in JSON
const convertBlobToJson = (blob: Blob): Promise<any> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const jsonData = JSON.parse(reader.result as string);
          resolve(jsonData);
        } catch (error) {
          reject(error);
        }
      };
      reader.readAsText(blob);
    });
  };

axios.interceptors.request.use((config) => {
    localStorage.setItem('lastActivity', new Date().toISOString())
    // const token = window.localStorage.getItem('jwt_p');
    // if (token) config.headers.Authorization = `Bearer ${token}`;
    const header = process.env.REACT_APP_HEADER;
    if (header) config.headers["tt-app"] = header;
    if (header) config.headers["X-Requested-With"] = "XMLHttpRequest";
    return config;
}, error => {
    return Promise.reject(error);
})

axios.interceptors.response.use(undefined, async capturedError => {
    let error = capturedError;
    
    // toast.error("interceptors");
    if(error){
        if ( error &&  error.response && error.response.data instanceof Blob) {
        // Se il tipo di contenuto è un Blob, converti il Blob in JSON
            try{
                error.response.data = await convertBlobToJson(error.response.data);
            }catch (blobConvertionEerror) {
                // Se il contenuto non è JSON, restituisci il Blob
                error.response.data = "";
            }
        }
        if (error && error.message === 'Network Error' && !error.response) {
            const isNativeApp = process.env.REACT_APP_IS_NATIVE_APP
                ? process.env.REACT_APP_IS_NATIVE_APP.toLocaleLowerCase() === "true"
                : false;
            if (!isNativeApp) 
                toast.error(getToastTranslation("network_error"), { toastId: `ApiError` })
        }
        if(error.response){
            const {status, data, config, headers} = error.response;
            if (status === 404) {
                if(data.errors.tenant && data.errors.tenant === "Not found"){
                    history.push('/');
                }
                //history.push('/notfound')
            }

            if(status === 401 && headers['www-authenticate'] && headers['www-authenticate'].includes('Bearer error="invalid_token", error_description="The token expired')) {
                history.push('/expired'); 
            }
          
            if(status === 403) {
                history.push('/');
                toast.error(getToastTranslation("forbidden_error"), { toastId: `ApiError` })
            }
            if ((status === 400)||(status === 417)) {
                if(data.errors.token && data.errors.token === "Token expired"){
                    let response : AxiosResponse<any> = error.response;
                    await Player.refreshToken().then(async () => 
                        response = await axios(config)
                        );
                    return response;
                } else if(data.errors.token && data.errors.token === "Token permanently expired"){
                    history.push('/expired');
                } else if(data.errors.token && data.errors.token === "Inactive user"){
                    history.push('/expired/true');
                } else if(data.errors.Tenant && data.errors.Tenant === "Not found"){
                    history.push('/');
                }else if(config.method === 'get' && data.errors.hasOwnProperty('id')){
                history.push('/notfound')
                }
            }
           
            if (status === 500) {
            }
        }
        //nel caso di browser come safari alcuni errori arrivano undefined e quindi non hanno .responce
        let response = capturedError;
        if(capturedError)
            response = capturedError.response;
        throw response;
    }
})


const responseBody = (response: AxiosResponse) => response.data;

const requests = {
    get: (url: string) => axios.get(url).then(responseBody),
    post: (url: string, body: {}) => axios.post(url, body).then(responseBody),
    put: (url: string, body: {}) => axios.put(url, body).then(responseBody),
    del: (url: string) => axios.delete(url).then(responseBody),
};


const multipartRequests = {
    PresentationDetails:(url: string, method: "post" | "put", values: PresentationDetailsFormValues) => {
        //console.log(" form data post" + JSON.stringify(values));
         let formData = new FormData();
         if(values.mainLanguageId) formData.append(`mainLanguageId`, values.mainLanguageId);
         values.presentationLanguages.forEach((node, index) => {
             if (node.id) formData.append(`presentationLanguages[${index}].Id`, node.id.toString());
             if (node.title) formData.append(`presentationLanguages[${index}].Title`, node.title);
             if (node.languageId) formData.append(`presentationLanguages[${index}].LanguageId`, node.languageId.toString());
             if(node.isMain)formData.append(`presentationLanguages[${index}].IsMain`, node.isMain.toString())
             if (node.attachedFiles) 
             Array.from(node.attachedFiles!).forEach(file => { formData.append(`presentationLanguages[${index}].AttachedFiles`, file) });
           
         
         });
 
         if (method === "put")
         return axios.put(url, formData, {
             headers: {'Content-Type' : 'multipart/form-data'}
         }).then(responseBody)
         else
         return axios.post(url, formData, {
             headers: {'Content-Type' : 'multipart/form-data'}
         }).then(responseBody)
     }
}

const Company = {
    details: (id: string) : Promise<ICompany> => requests.get(`/public/companies/` + id),
    list: (): Promise<ICompany[]> => requests.get('/companies/list'),
    languages: (): Promise<ILanguage[]> => requests.get('/public/companies/languages'),
    registrationSettings: (id: number) : Promise<ICompanyRegistrationSettings> => requests.get(`/public/companies/registrationSettings/` + id),
}

const User = {
    current: (): Promise<IUser> => requests.get('/user'),
    login: (user: IUserFormValues): Promise<IUser> => requests.post('/public/user/login', user),
    refreshActivity: (): Promise<any> => requests.post('/user/refreshActivity', {}),
    logout: (): Promise<any> => requests.post('/public/user/logout', {}),
    logOutSSO: (): Promise<any> => requests.get('/logout-oidc'),
    resetpwd: (user: IResetPwdFormValues) => requests.put('/public/user/resetpwd', user),
    confirmresetpwd: (userConfirmPwd: IUserConfirmResetPwdValues) => requests.put('/public/user/confirmresetpwd', userConfirmPwd),
    details: (userId: string): Promise<IUserProfile> => requests.get(`/user/${userId}`),
    updateCurrent: (profile: IUserProfileFormValues) => requests.put(`/user`, profile),
    changePwd: (values: IChangePwdFormValues) => requests.put('/user/updatepwd', values),
    register: (user: RegistrationFormValues): Promise<IUser> => requests.post('/public/user/register', user),
    loginOtp: (user: IOtpFormValues): Promise<IUser> => requests.post('/public/user/otplogin', user),
    OtpRequest: (user: IOtpFormValues): Promise<IUser> => requests.post('/public/user/otprequest', user),
    loginCustomStep1: (user: IUserFormValues): Promise<boolean> => requests.post('/public/user/customstep1', user),
    loginCustomStep2: (user: IOtpFormValues): Promise<IUser> => requests.post('/public/user/customstep2', user),
    updatelanguage: (languageId: number): Promise<any> => requests.put(`/player/user/updatelanguage?languageId=${languageId}`, { languageId: languageId }),
    loginAuthenticatorAppStep1: (user: IUserFormValues): Promise<LoginAuthenticatorApp> => requests.post('/public/user/authenticatorApp', user),
    getAuthenticatorAppInfo: (token: string, companyId: number ): Promise<AuthenticatorQRcodeInfo> => requests.get(`/public/user/authenticatorQrCode/${token}/${companyId}`),
    loginAuthenticatorStep2: (user: IOtpFormValues): Promise<IUser> => requests.post('/public/user/authenticatorLoginStep2', user),
    reset2FA_APP: (user: IAuthenticatorFormValues) => requests.put('/public/user/authenticatorAppReset', user),
    confirmDeleteAuthenticatorApp: (user: IUserFormValues): Promise<LoginAuthenticatorApp> => requests.post('/public/user/authenticatorAppRemove', user),
}

const Tenant = {
    list: (): Promise<ITenant[]> => requests.get('/user/tenants'),
}

const Meeting = {
    nodes: (meetingId: number, languageId?: number): Promise<IMeetingContentTreePageDto> => requests.get(`player/meetings/${meetingId}/nodes${languageId ? `?languageId=${languageId}` : ``}`),
    content: (nodeId: number, languageId?: number): Promise<IPlayerContent> => requests.get(`player/meeting/nodes/${nodeId}${languageId ? `?languageId=${languageId}` : ``}`),
    details: (meetingId: number): Promise<IMeetingEditPageDto> => requests.get(`/meetings/${meetingId}`),
    nodeDetails: (meetingId: number, nodeId: number): Promise<INodeDetail[]> => requests.get(`/meetings/${meetingId}/nodes/${nodeId}`),
    refreshMeeting: (tenantId: number) : Promise<IPlayerSignin> => requests.post(`/player/meeting/${tenantId}/refreshMeeting`, {}),
}

const Board = {
    main: (languageId?: number): Promise<IBoardTreePageDto> => requests.get(`/boards${languageId ? `?languageId=${languageId}` : ``}`),
    content: (nodeId: number, languageId?: number): Promise<IPlayerContent> => requests.get(`player/board/nodes/${nodeId}${languageId ? `?languageId=${languageId}` : ``}`),
}

const Content = {
    // imageOrVideo: (url: string) => axios.get(url, {
    //     responseType: 'blob'
    // }),
    imageOrVideo: (url: string) => {
        const sourcecancellation = axios.CancelToken.source();
        var axios_result= axios.get(url, {
        responseType: 'blob',
        cancelToken: sourcecancellation.token
    })
    return  {result: axios_result, sourcecancellation:  sourcecancellation};
     } ,
     /*questa funzione potrebbe essere usata per caricare più immagini o video in una volta... da sistemare il return*/
     /* imageOrVideoArray: (urls: string[]) => {
        const sourcecancellation = axios.CancelToken.source();
        const requests = urls.map(url => axios.get(url, {
            responseType: 'blob',
            cancelToken: sourcecancellation.token
        }));
    
        axios.all(requests).then(axios.spread((...responses) => {
            // Qui puoi gestire ogni risposta. Ad esempio:
            responses.forEach((response, index) => {
                console.log(`Risposta ${index + 1}:`, response);
                // Qui puoi fare qualcosa con ogni risposta, ad esempio mostrare un'immagine o un video
            });
        })).catch(errors => {
            // gestisci gli errori
            console.error(errors);
        });
        return  {result: axios_result, sourcecancellation:  sourcecancellation};
    }, */
    // download: (url: string) => axios.get(url, {responseType: 'blob'}),
    download: (url: string) => {
        const sourcecancellation = axios.CancelToken.source();
        var axios_result= axios.get(url, {
        responseType: 'blob',
        cancelToken: sourcecancellation.token
    })
    return  {result: axios_result, sourcecancellation:  sourcecancellation};
     } ,
    customWatermark: (contentId: number) => axios.post(`content/customwatermark/${contentId}`),
    loadZwibblerDrawing: (fileId: number): Promise<IZwibblerDrawing> => axios.get(`content/zwibbler/${fileId}`),
    saveZwibblerDrawing: (drawing: IZwibblerDrawingFormValues) => axios.post(`content/zwibbler`, drawing),
    checkPresentationIsReady: (contentsIds: number[]): Promise<number> => {
        const queryString = contentsIds.map(id => `contentsIds=${id}`).join('&');
        return requests.get(`/public/content/checkIfContentsAreReady?${queryString}`);
    }
}

const Player = {
    signin: (tenantId: number) : Promise<IPlayerSignin> => requests.post(`/player/tenants/${tenantId}/signin`, {}),
    refreshToken: (): Promise<IPlayerSignin> => requests.post(`/player/tenants/refreshToken`, {}),
    startSignalR: (): Promise<string> => requests.get(`/player/startSignalR`),
    // refreshToken: (tenantId: number): Promise<IPlayerSignin> => requests.post(`/player/tenants/${tenantId}/refreshToken`, {}),
    links: (): Promise<ISidebar> => requests.get(`/player/links`),
    toolbar: (contentId: number): Promise<IToolbar> => requests.get(`/player/toolbar/${contentId}`),
    searchAll: (options: ISearchOptions) : Promise<ISearchPageDto> => requests.post('/search', options),
    loadSurveyAnswerDetail: (meetingId : number, surveyId: number, languageId?: number):Promise<SurveyDetailsPlayerDto> => 
        requests.get(`/survey/${meetingId}/${surveyId}/SurveyDetailsPlayer${languageId ? `?languageId=${languageId}` : ``}`),
    zoomPortion: (infoPortion: zoomPortionValue) : Promise<number>=> requests.post('/public/player/zoomPortion', infoPortion),


    }

const Survey={
    list: (meetingId : number, languageId?: number):Promise<ISurveyPageDto> => requests.get(`/survey/${meetingId}/ListSurvey${languageId ? `?languageId=${languageId}` : ``}`),
    create: (survey: SurveyDetailFormValues) : Promise<number>=> requests.post('/survey', survey),
    update: (surveyId: number, survey: SurveyDetailFormValues) => requests.put(`/survey/${surveyId}/UpdateSurvey`, survey),
    details: ( meetingId: number, surveyId: number): Promise<ISurveyDetailsDto> => requests.get(`/survey/${meetingId}/${surveyId}`),
    listSurveyTypes: (): Promise<ISurveyType[]> => requests.get('/public/survey/ListSurveyType'),
    listSurveyResponses:(meetingId : number, surveyQuestionId : number):Promise<SurveyReponsesPageDto> => requests.get(`/survey/${meetingId}/${surveyQuestionId}/ListSurveyResponse`),
    detailsResponses: (surveyResponseId: number): Promise<ISurveyEditResponseDto> =>   requests.get(`/survey/${surveyResponseId}/DetailsResponses`),
    updateResponses:(surveyResponseId: number ,surveyResponse : SurveyResponseFormValue ) => requests.put(`/survey/${surveyResponseId}/UpdateResponse`,surveyResponse),
    AddResponse: (surveyId: number ,surveyResponse : SurveyResponseFormValue ) => requests.post(`/survey/${surveyId}/AddResponse`,surveyResponse),
    deleteResponse: (surveyResposeId : number) => requests.del(`/survey/${surveyResposeId}/DeleteResponse`),
    deleteSurvey : (surveyId: number) => requests.del(`/survey/${surveyId}/DeleteSurvey`),
    eventSurvey: (surveyId : number, surveyEvent : SurveyEvent) => requests.post(`/survey/${surveyId}/EventSurvey`, surveyEvent),
    clearAnswers : (surveyId : number) => requests.del(`/survey/${surveyId}/ClearSurveyAnswers`),
    loadQuorumResult: (meetingId: number , surveyId: number) : Promise<IQuorumResultDto> =>  requests.get(`/survey/${meetingId}/${surveyId}/QuorumResult`),
    loadSurveyByNode:(nodeId : number):Promise<ISurveyPageDto> => requests.get(`/survey/${nodeId}/ListSurveyByNode`),
    addAnswers: (surveyId:number, surveyAnswers:{surveyId:number, surveyResponsesId: number[]} ) => requests.post(`/survey/${surveyId}/AddAnswer`, surveyAnswers),
    addFreeAnswer: (surveyId:number, answer: string ) => requests.post(`/survey/${surveyId}/AddAnswerfree`, { answer : answer }), 
    loadSurveyResult: (meetingId : number, surveyId: number, languageId?: number):Promise<ISurveyResult> => requests.get(`/survey/${meetingId}/${surveyId}/SurveyResults${languageId ? `?languageId=${languageId}` : ``}`),
    addAnswerVote: (surveyId: number, surveyVote: Votes) => requests.post(`/survey/${surveyId}/AddAnswerVote`, surveyVote),
}

const RepositoryUser={
    repository: (): Promise<IRepositoryUserTreePageDto> => requests.get(`/presentation/repositoryUser`),
    presentationDetailsPlayer: (presentationId:number): Promise<PresentationDetailDto> => requests.get(`/presentation/${presentationId}/presentationDetailsPlayer`),
    addPresentation: ( parentNodeId: number | undefined, nodeDetails : PresentationDetailsFormValues, isVisibleOnPodium : boolean | undefined, isGlobalGuestRequest : boolean | undefined) : Promise<IResultUploadFilesDto> => multipartRequests.PresentationDetails(`/public/presentation/AddPresentation/${isVisibleOnPodium ? isVisibleOnPodium : false}/${parentNodeId ? parentNodeId: ''}${isGlobalGuestRequest ? "?isGlobalGuestRequest=" + isGlobalGuestRequest: ''}`, "post", nodeDetails),
    details: (presentationId: number): Promise<IPresentationEditPageDto> => requests.get(`/presentation/${presentationId}/PresentationDetail`),
    updatePresentation: ( presentationId: number | undefined, nodeDetails : PresentationDetailsFormValues) => multipartRequests.PresentationDetails(`/presentation/${presentationId}/UpdatePresentation`, "post", nodeDetails),
    addPresentationNode: ( presentationId: number | undefined, nodeDetails : PresentationDetailsFormValues) => multipartRequests.PresentationDetails(`/presentation/AddPresentationNode/${presentationId}`, "post", nodeDetails),
    deletePresentation: (presentationId : number) => requests.del(`/presentation/${presentationId}/DeletePresentation`),
    getUserSpaceDisk: (): Promise<IDiskUser> => requests.get('/presentation/diskUser'),
}

const Note={
    getContentNote: (contentId: number): Promise<INote> => requests.get(`/notes/content/${contentId}`),
    postContentNote: (contentId: number, note: INote) => requests.post(`/notes/content/${contentId}`, note),
    deleteContentNote: (contentId: number) => requests.del(`/notes/content/${contentId}`),
    getFileNote: (fileId: number): Promise<INote> => requests.get(`/notes/file/${fileId}`),
    postFileNote: (fileId: number, note: INote) => requests.post(`/notes/file/${fileId}`, note),
    deleteFileNote: (fileId: number) => requests.del(`/notes/file/${fileId}`),
}

const Screen={
    moveScreenConnectionUp: (connectionId: number) => requests.put(`/player/screens/connection/${connectionId}/order/up`, {}),
    moveScreenConnectionDown: (connectionId: number) => requests.put(`/player/screens/connection/${connectionId}/order/down`, {}),
    changeScreenConnectionSelection: (connectionId: number): Promise<number> => requests.put(`/player/screens/connection/${connectionId}/selection`, {}),
    changeScreenConnectionActivation: (connectionId: number, removeWidget: boolean): Promise<number> => requests.put(`/player/screens/connection/${connectionId}/activation`, {removeWidget: removeWidget}),
    connectToScreen: (code: string): Promise<IScreenStatus> => requests.post(`/player/screens/connection`, { code: code }),
    changeScreenConnectionLabel: (connectionId: number, label: string) => requests.put(`/player/screens/connection/${connectionId}/label`, { label: label }),
    deleteScreeenConnection: (connectionId: number) => requests.del(`/player/screens/connection/${connectionId}`),
    regeneratePersonalScreen: () : Promise<IScreenStatus> => requests.post(`/player/screens/regenerate`, {}),
    reloadScreenConnections: () : Promise<IUserScreens> => requests.get(`/player/screens/connection/reload`),
    shareWidget: (widget: SharedWidgetType, connections: number[]) => requests.post(`/player/screens/share`, { widget: widget, connections: connections }),
    clearScreenConnections: ()  => requests.post(`/player/screens/connection/clear`, {}),
    showWidgetZoomPortion: ( connections: number[]) => requests.post(`/player/showzoomPortion`, {connections: connections}),
}

const Podium={
    podiumData: (meetingId: number, userId: number): Promise<IPodiumData> => requests.get(`/podium/meetings/${meetingId}/${userId}/speakers`),
    podiumDataPreview: (meetingId: number, preview:boolean): Promise<IPodiumData> => requests.get(`/podium/meetings/${meetingId}/speakers/preview`),
    validatePin: (podiumId: number, speakerId: number, pin: string): Promise<boolean> => requests.post(`/podium/${podiumId}/speakers/${speakerId}/pin`, { pin : pin }),
    validatePodiumLogout: (password: string): Promise<boolean> => requests.post(`/podium/logout`, { password: password }),
    speakerContent: (meetingId: number, speakerId: number): Promise<ISpeakerContent> => requests.get(`/podium/meetings/${meetingId}/speakers/${speakerId}`),
    showQrCode: () => requests.post(`/podium/showqr`, {}),
    showStandby: (meetingId: number) => requests.post(`/podium/meetings/${meetingId}/standby`, {}),
    previewByCode: (companyId: number): Promise<IPodiumData> => requests.get(`/podium/companies/${companyId}/preview/`),
}

const Guest = {
    presentation: (companyId: number, pin? : string): Promise<IGuestContent> => requests.get(`/public/guest/companies/${companyId}/presentation${pin ? `?pin=${pin}` : ``}`),
    authPresentationPin: (companyId: number, pin: string, zone: string, presentationId? : number): Promise<IValidatedGuest> => requests.post(`/public/guest/companies/${companyId}/auth`, { pin : pin, zone : zone, presentationId : presentationId }),
    presentationByCode: (companyId: number, zone: string): Promise<boolean> => requests.get(`/public/guest/companies/${companyId}/${zone}/guest`),
    logout: () :Promise<number> => requests.post(`/public/guest/logout`, {}),
    getScreenByCode: (companyId: number, zonecode: string): Promise<IScreenInfo> =>requests.post(`/public/guest/companies/${companyId}/screenCode`, { code: zonecode }),
    presentationInfo: (presentationId: number, pin: string): Promise<IPresentationInfo> => requests.get(`/public/guest/presentationInfo/${presentationId}/${pin}`),
}
const Archive = {
    list: (): Promise<INodeGeneric[]> => requests.get(`/archive/listForPlayer`),
    GetArchiveContents: (archiveId: number): Promise<IContentTreePageDto> => requests.get(`/archive/getArchiveContents/${archiveId}`),
    GetArchiveBrowsePageDetails: (archiveId: number,contentId: number): Promise<PlayerBrowsePageDto> => requests.get(`player/archive/${archiveId}/${contentId}/BrowsePageDetails`)
}
const Broadcast = {
    createSession: (sessionId: string, meetingId : number, userType? : UserTypes) : Promise<string> => requests.post('public/broadcast/sessions',userType ? {customSessionId: sessionId, meetingId : meetingId, userType: userType}: {customSessionId: sessionId, meetingId : meetingId}),
    closeSession: (sessionId: string) => requests.del(`broadcast/sessions/${sessionId}`),
    connectToSession: (sessionId: string, userType : UserTypes, connectionData : string, stationId? : string) : Promise<BroadcastDto> => requests.post('public/broadcast/sessions/' + sessionId + '/connections/' + userType + (stationId !== "" ? `?stationId=${stationId}` : ""), {connectionData}),
    synchronizeSession: (sessionId: string, lastUpdateDate : Date, connectionId : string) : Promise<SynchronizedBroadcastStatus> => requests.post('public/broadcast/sessions/' + sessionId + '/synchronizeSession', {lastUpdateDate: lastUpdateDate, connectionId: connectionId}),
    updateSession: (sessionId: string, broadcastUserDataDto : BroadcastUserDataDto) => requests.post('public/broadcast/sessions/' + sessionId + '/updateSession',{broadcastUserDataDto}),
    leaveSession: (sessionId: string, broadcastUsersDataDto : BroadcastUserDataDto[]) => requests.post('public/broadcast/sessions/' + sessionId + '/leaveSession',{broadcastUsersDataDto}),
}

const Cabolo={
    download: (url: string) => {
        const sourcecancellation = axios.CancelToken.source();
        var axios_result=  axios.get(url, {
        responseType: 'blob',
        cancelToken: sourcecancellation.token
    })
    return  {result: axios_result, sourcecancellation:  sourcecancellation};},
    getRecordingMeetingCabolo: (meetingId: number): Promise<IRecordingMeetingPageDto> => requests.get(`/cabolo/recordingsMeeting/${meetingId}`),
    deleteRecordingMeetingCabolo: (id: number) => requests.del(`/cabolo/recordingsMeeting/delete/${id}`),
    getCaboloMeetingInfo: (meetingId: number): Promise<ICaboloMeetingInfo> => requests.get(`/cabolo/caboloMeetingInfo/${meetingId}`),
    getCaboloStatus: (caboloId: number): Promise<CaboloStatus> => requests.get(`/cabolo/status/${caboloId}`),
    getAudioDevices: (caboloId: number): Promise<AudioDevice[]> => requests.get(`/cabolo/audio_devices/${caboloId}`),
    getTranscriptionModels: (caboloId: number): Promise<TranscriptionModel[]> => requests.get(`/cabolo/transcriptionsModels/${caboloId}`),
    getlanguagePairs: (caboloId: number): Promise<LanguagePair[]> => requests.get(`/cabolo/languagepairs/${caboloId}`),
    startRegistration: (values: IcaboloRecodingFormValues) => requests.post(`/cabolo/startRecording`, values),
    stopRecording: (recording: IcaboloRecodingFormValues) => requests.post('/cabolo/stopRecording', recording),
    pauseRecording: (recording: IcaboloRecodingFormValues) => requests.post('/cabolo/pauseRecording', recording),
    resumeRecording: (recording: IcaboloRecodingFormValues) => requests.post('/cabolo/resumeRecording', recording),
    getRecStatusCabolo: (caboloId: number): Promise<RecStatus> => requests.get(`/cabolo/recstatus/${caboloId}`),
    startInterruptedRecording: (recording: IcaboloRecodingFormValues) => requests.post('/cabolo/startInterruptedRecording', recording),

}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    Company,
    User,
    Tenant,
    Meeting,
    Board,
    Content,
    Player,
    Survey,
    RepositoryUser,
    Note,
    Screen,
    Podium,
    Guest,
    Archive,
    Broadcast,
    Cabolo
}